<script>
import _ from 'lodash'
import AscStatusMethodsMixin from './AscStatusMethodsMixin.vue'

export default {
  mixins: [AscStatusMethodsMixin],

  computed: {
    getTableDefinition() {
      let headings = []
      let values = []
      if (this.definition.thresholds && this.definition.thresholds.length > 0) {
        // get first threshold to build headings
        const first = this.definition.thresholds[0]
        headings = Object.keys(first).map(item => {
          if (this.isValidStatus(item)) {
            return this.getStatusTitle(item)
          }
          return _.startCase(item)
        })

        // iterate through all thresholds and build
        values = this.definition.thresholds.map(threshold => {
          const mappedItems = Object.values(threshold).map(item => {
            return {
              text: item,
            }
          })
          return mappedItems
        })
      }

      return {
        headings: headings,
        values: values,
      }
    },
  },
}
</script>
